(function ($) {
	class Tabs {
		constructor(element) {
			this.element = $(element);
			this.init();
		}

		init() {
			this.tabs = $('.tabs-button', this.element);
			this.tabContent = $('.tabs-content', this.element);

			this.tabs.on('click', this.onTabClick.bind(this));
		}

		onTabClick(e) {
			e.preventDefault();

			const tab = $(e.currentTarget);
			const tabContent = this.tabContent.filter(`[data-tab="${tab.data('tab')}"]`);

			this.tabs.removeClass('is-active');
			this.tabContent.removeClass('is-active');

			this.tabs.filter(`[data-tab="${tab.data('tab')}"]`).addClass('is-active');
			tabContent.addClass('is-active');

			$(window).trigger('resize');
		}
	}

	$('.tabs').each((i, el) => new Tabs(el));
})(jQuery);